import * as types from './types';

// chartId is no longer used. Leaving to be compatible with legacy store structure
const selectedMetricChart = (metricName, chartId = '', append = false) => ({
  type: types.SELECTED_METRIC_CHART,
  metricName,
  chartId,
  append,
});

const init = () => ({
  type: types.INIT,
});

const setMetrics = metrics => ({
  type: types.SET_METRICS,
  metrics,
});

const setLoadingState = () => ({
  type: types.SET_LOADING_STATE,
});

const addSummaryMetric = metric => ({
  type: types.ADD_SUMMARY_METRIC,
  metric,
});

const saveChartData = chartData => ({
  type: types.SAVE_CHART_DATA,
  chartData,
})

export {
  selectedMetricChart,
  init,
  setMetrics,
  setLoadingState,
  addSummaryMetric,
  saveChartData,
};
